var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.2,
    stroke: "#E60000",
    strokeOpacity: 0.81,
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8713 14.0806C16.8234 14.4036 17.7268 14.9338 18.5959 15.6081C18.8927 15.8384 19.0434 16.231 18.9891 16.6206C18.8921 17.3166 18.7742 17.9865 18.6308 18.6256C18.4376 19.4866 17.6933 20.0684 16.8738 19.9935C14.3784 19.7654 11.7298 18.4529 9.58319 16.1412C7.43656 13.8294 6.21786 10.9771 6.00602 8.2898C5.93644 7.40718 6.47669 6.60562 7.27621 6.39759C7.86968 6.24318 8.49176 6.11618 9.13799 6.01177C9.49979 5.95331 9.86438 6.11551 10.0782 6.43519C10.7043 7.37106 11.1967 8.34406 11.4966 9.36937C11.6249 9.80792 11.4753 10.2858 11.1255 10.5494L9.81118 11.5395C10.3121 12.3845 10.9138 13.1981 11.615 13.9531C12.3161 14.7082 13.0716 15.3562 13.8561 15.8956L14.7755 14.4803C15.0203 14.1035 15.4641 13.9424 15.8713 14.0806Z",
    fill: "#E60000",
    fillOpacity: 0.81
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCallIcon);
export default __webpack_public_path__ + "static/media/redCall-icon.226585ad1ac099b0a38f6f6abfc6f4d9.svg";
export { ForwardRef as ReactComponent };